<template>
  <v-card class="mb-4">
    <v-card-title class="d-flex align-center justify-space-between">
      <span>
        <v-icon class="mr-2" color="blue">mdi-cart-outline</v-icon>
        {{ t.dashboard?.orders_stats || 'Orders Statistics' }}
      </span>
      <div class="d-flex align-center ga-2">
        <v-btn-toggle v-model="period" density="compact" mandatory @update:modelValue="loadStats">
          <v-btn value="today" size="small">{{ t.dashboard?.today || 'Today' }}</v-btn>
          <v-btn value="current_month" size="small">{{ t.dashboard?.month || 'Month' }}</v-btn>
          <v-btn value="last_month" size="small">{{ t.dashboard?.last_month || 'Last m.' }}</v-btn>
        </v-btn-toggle>
        <v-btn
          icon
          size="small"
          variant="text"
          :loading="loading"
          @click="loadStats"
          :title="t.dashboard?.reload || 'Reload'"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-text>
      <v-progress-circular v-if="loading" indeterminate size="24" class="mr-2" />

      <template v-else>
        <v-row>
          <v-col cols="6" md="4">
            <v-card variant="tonal" color="primary" class="text-center pa-3">
              <div class="text-h4">{{ summary.totals?.order_count || 0 }}</div>
              <div class="text-caption">{{ t.dashboard?.orders || 'Orders' }}</div>
            </v-card>
          </v-col>
          <v-col cols="6" md="4">
            <v-card variant="tonal" color="success" class="text-center pa-3">
              <div class="text-h4">{{ formatCost(summary.totals?.total_cost) }}</div>
              <div class="text-caption">{{ t.dashboard?.total_eur || 'Total (EUR)' }}</div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card variant="tonal" color="info" class="text-center pa-3">
              <div class="text-h4">{{ (summary.by_service_type || []).length }}</div>
              <div class="text-caption">{{ t.dashboard?.service_types || 'Service types' }}</div>
            </v-card>
          </v-col>
        </v-row>

        <v-list v-if="(summary.by_service_type || []).length > 0" density="compact" class="mt-2">
          <v-list-item v-for="st in summary.by_service_type" :key="st.service_type_id">
            <v-list-item-title>{{ st.service_type_name }}</v-list-item-title>
            <template v-slot:append>
              <span class="text-body-2 mr-3">{{ st.order_count }} {{ t.dashboard?.orders_count || 'orders' }}</span>
              <v-chip size="small" color="success">{{ formatCost(st.total_cost) }} EUR</v-chip>
            </template>
          </v-list-item>
        </v-list>
        <div v-else class="text-center text-grey mt-2">{{ t.dashboard?.no_orders_period || 'No orders in this period' }}</div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'
import { getOrderSummaries } from '@/composables/useGetOrdersAPI'
import store from '@/store'

export default {
  name: 'OrdersStatsSection',
  props: {
    config: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      summary: {},
      loading: true,
      period: 'current_month'
    }
  },
  computed: {
    t() { return tRef.value },
    token() {
      return store.getters.getToken
    }
  },
  async mounted() {
    await this.loadStats()
  },
  methods: {
    async loadStats() {
      this.loading = true
      try {
        const result = await getOrderSummaries(this.token, {
          include_subclients: true,
          period: this.period,
          detail_level: 'summary'
        })
        if (!result.error) {
          this.summary = result.summary || {}
        }
      } finally {
        this.loading = false
      }
    },
    formatCost(val) {
      const num = parseFloat(val) || 0
      return num.toFixed(2)
    }
  }
}
</script>
